import { connect } from "react-redux";

import {
  toggleDeleteModal,
  toggleDeliveryModal,
  toggleEditModal,
} from "../../redux/modals";
import {
  fetchCalendar,
  openEvent,
  rescheduleEventExplicit,
  scheduleBid,
  scheduleJobExplicit,
  schedulePurchaseOrderExplicit,
  setActiveCrew,
  hideMenuItem,
} from "../../redux/calendar";
import makeEventsByCrew from "../../selectors/eventsByCrew";
import { open as togglePrintWorkOrderModal } from "../../redux/modals/printWorkOrderModal";
import {
  togglePinTotalsRow as togglePinTotalsRow,
  showEstimatedQuantitiesSelector,
} from "../../redux/settings";
import WeekView from "./WeekView";

const eventsByCrew = makeEventsByCrew(true);

const mapStateToProps = (state) => ({
  date: state.calendar.date,
  eventsByCrew: eventsByCrew(state),
  hasCalendarEventCreate:
    state.tokenInfo.scope.indexOf("calendarEvents:create") > -1,
  hasCalendarEventDelete:
    state.tokenInfo.scope.indexOf("calendarEvents:delete") > -1,
  hasCalendarEventUpdate:
    state.tokenInfo.scope.indexOf("calendarEvents:update") > -1,
  showTotalsRow: state.settings.totalsRowFields.fields.showTotalsRow.visible,
  showUOMTotals:
    state.settings.totalsRowFields.fields.statistics.uomTotals.visible,
  showJobCounts:
    state.settings.totalsRowFields.fields.statistics.jobCounts.visible,
  includedItemTypes: state.settings.totalsRowFields.fields.includedItemTypes,
  showEstimatedQuantities: showEstimatedQuantitiesSelector(state),
  showMenuItem: state.calendar.showMenuItem,
  settings: state.settings,
  mode: state.calendar.mode,
  pinTotalsRow: state.settings.pinTotalsRow,
});

const mapDispatchToProps = {
  onCrewSelect: setActiveCrew,
  onNavigate: fetchCalendar,
  onDeleteEventClick: toggleDeleteModal,
  onEditDeliveryClick: toggleDeliveryModal,
  onEditEventClick: toggleEditModal,
  onOpenClick: openEvent,
  onReschedule: rescheduleEventExplicit,
  onScheduleBid: scheduleBid,
  onScheduleDelivery: schedulePurchaseOrderExplicit,
  onScheduleJob: scheduleJobExplicit,
  onPrintWorkOrder: togglePrintWorkOrderModal,
  onContextMenuClick: hideMenuItem,
  onTogglePinTotalsRow: togglePinTotalsRow,
};

const mergeProps = (
  {
    hasCalendarEventCreate,
    hasCalendarEventDelete,
    hasCalendarEventUpdate,
    ...stateProps
  },
  {
    onDeleteEventClick,
    onEditDeliveryClick,
    onEditEventClick,
    onReschedule,
    onScheduleBid,
    onScheduleDelivery,
    onScheduleJob,
    onPrintWorkOrder,
    ...dispatchProps
  },
  ownProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onDeleteEventClick: hasCalendarEventDelete ? onDeleteEventClick : null,
  onEditDeliveryClick: hasCalendarEventUpdate ? onEditDeliveryClick : null,
  onEditEventClick: hasCalendarEventUpdate ? onEditEventClick : null,
  onScheduleBid: hasCalendarEventCreate ? onScheduleBid : null,
  onReschedule: hasCalendarEventUpdate ? onReschedule : null,
  onScheduleDelivery: hasCalendarEventCreate ? onScheduleDelivery : null,
  onScheduleJob: hasCalendarEventCreate ? onScheduleJob : null,
  onPrintWorkOrder: hasCalendarEventUpdate ? onPrintWorkOrder : null,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WeekView);
